'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validUrlQueryChars = require('./validUrlQueryChars');

var _validUrlQueryChars2 = _interopRequireDefault(_validUrlQueryChars);

var _validUrlQueryEndingChars = require('./validUrlQueryEndingChars');

var _validUrlQueryEndingChars2 = _interopRequireDefault(_validUrlQueryEndingChars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validTcoUrl = (0, _regexSupplant2.default)(/^https?:\/\/t\.co\/([a-z0-9]+)(?:\?#{validUrlQueryChars}*#{validUrlQueryEndingChars})?/, { validUrlQueryChars: _validUrlQueryChars2.default, validUrlQueryEndingChars: _validUrlQueryEndingChars2.default }, 'i'); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validTcoUrl;
module.exports = exports['default'];